import { useTheme } from '../contexts/ThemeContext';

function GameInstructionsModal({
    isOpen,
    onClose,
    title,
    sections = [],
    closeLabel = 'Got it'
}) {
    const { theme } = useTheme();
    const isMobile = window.innerWidth <= 768;

    if (!isOpen) {
        return null;
    }

    return (
        <div
            onClick={onClose}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.82)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2200,
                padding: isMobile ? '12px' : '20px'
            }}
        >
            <div
                onClick={(event) => event.stopPropagation()}
                style={{
                    width: '100%',
                    maxWidth: '760px',
                    maxHeight: '88vh',
                    overflowY: 'auto',
                    backgroundColor: theme.bgMedium,
                    border: `2px solid ${theme.light}`,
                    borderRadius: '14px',
                    padding: isMobile ? '16px' : '22px',
                    boxSizing: 'border-box'
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'center' }}>
                    <h2 style={{ margin: 0, color: theme.accent, fontSize: isMobile ? '1.25rem' : '1.6rem' }}>
                        {title}
                    </h2>
                    <button
                        onClick={onClose}
                        style={{
                            border: 'none',
                            backgroundColor: 'transparent',
                            color: theme.textPrimary,
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            lineHeight: 1,
                            padding: '2px 8px'
                        }}
                        aria-label="Close instructions"
                    >
                        x
                    </button>
                </div>

                <div style={{ display: 'grid', gap: '14px', marginTop: '14px' }}>
                    {sections.map((section, index) => (
                        <section
                            key={`${section.heading}-${index}`}
                            style={{
                                backgroundColor: theme.bgDark,
                                border: `1px solid ${theme.secondary}`,
                                borderRadius: '10px',
                                padding: isMobile ? '10px' : '12px'
                            }}
                        >
                            <h3 style={{ margin: '0 0 8px 0', color: theme.textPrimary, fontSize: isMobile ? '1rem' : '1.1rem' }}>
                                {section.heading}
                            </h3>

                            {(section.paragraphs || []).map((paragraph, paragraphIndex) => (
                                <p
                                    key={`${section.heading}-p-${paragraphIndex}`}
                                    style={{ margin: '0 0 8px 0', color: theme.textSecondary, lineHeight: 1.5 }}
                                >
                                    {paragraph}
                                </p>
                            ))}

                            {section.bullets && section.bullets.length > 0 && (
                                <ul style={{ margin: 0, paddingLeft: '18px', color: theme.textSecondary, lineHeight: 1.5 }}>
                                    {section.bullets.map((bullet, bulletIndex) => (
                                        <li key={`${section.heading}-b-${bulletIndex}`} style={{ marginBottom: '4px' }}>
                                            {bullet}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </section>
                    ))}
                </div>

                <button
                    onClick={onClose}
                    style={{
                        width: '100%',
                        marginTop: '16px',
                        padding: isMobile ? '10px 14px' : '12px 16px',
                        border: 'none',
                        borderRadius: '8px',
                        backgroundColor: theme.accent,
                        color: theme.textPrimary,
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        fontFamily: 'inherit'
                    }}
                >
                    {closeLabel}
                </button>
            </div>
        </div>
    );
}

export default GameInstructionsModal;
